import { render } from "./ChevronDownIcon.vue?vue&type=template&id=27750669"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=js"
script.render = render

export default script